import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import CircledIcon from '../../../components/CircledIcon';
import useMobile from '../../../hooks/useMobileHook';
import GenericTable from '../../../components/GenericTable';
import { formatPrice } from '../../../utils/utils';
import IconButton from '../../../components/IconButton';
import { useState } from 'react';
import DefaultCard from '../../../components/DefaultCard';
import Link from '../../../components/Link';

export type customLifestyleBenefitsTabProps = {
  lifestyleBenefits: any;
  headerTitle?: String;
};

const LifestyleBenefitsTab = ({
  lifestyleBenefits,
  headerTitle,
}: customLifestyleBenefitsTabProps) => {

  const isMobile = useMobile();
  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const getTableData = (plans: Array<any>) => {
    const rows = plans.map( (plan) => {
      return [plan.title, formatPrice(plan.cost)];
    });
    return {
      headers: ['Option', 'Per Pay Period Cost'],
      rows: rows
    };
  }

  const getCellCoordinates = (benefit: any) => {
    let y = 1;
    benefit['availablePlans'].map(
      (b: any, i: number) => {
        if (b.id === benefit['plan'].id) y = i;
        return b;
      }
    );    
    return [y,1];
  }

  const icon = (iconName: IconProp) => (
    <CircledIcon
      variant={'icon-emphasized'}
      size={isMobile ? 'icon-sm' : 'icon-lg'}
      icon={iconName}
    />
  );

  const getCardIcon = (type: String) => {
    switch (type) {
      case 'gavel':
        return light('gavel');
      default:
        return light('image-slash');
    }
  };

  return (
    <Container className={'px-0'}>
      <Row className={`align-items-center ${headerTitle ? 'mt-8' : ''}`}>
        <Col className={'col-12 col-lg-6'}>
          {headerTitle && <span className={'text-sm-16-lg-24 fw-normal lx-xxs'}>
            {headerTitle}
          </span>}
        </Col>
        <div>
          {lifestyleBenefits.map((benefit: any, index: number) => {
            return (
              <Container className={`m-0 ${index || headerTitle ? 'mt-10' : ''} p-10 border border-info rounded-1`}>
                <div className={'d-flex justify-content-between align-items-center mb-10'}>
                  <Col>
                    {icon(getCardIcon(benefit['generic'].icon))}
                    <span className={'h5 mb-0 ms-4'}>{benefit['generic'].title}</span>
                  </Col>
                  <div onClick={() => toggleDetails()} className={'icon-button-wrapper'}>
                    <IconButton
                      variant="icon-default"
                      icon={light('circle-exclamation')}
                      extLabel="Benefit Info"
                    />
                  </div>
                </div>
                <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
                  <div className="d-flex justify-content-center">
                    <DefaultCard
                      closeButton={
                        <Link 
                          className='pt-0' 
                          isAlignAtEnd 
                          isWhiteIcon 
                          rightIcon={light('close')}
                          onClick={() => toggleDetails()}
                        />                      
                      }
                      variant="blue-motif"
                      leftHeading={
                        'Want to know about Legal Services?'
                      }
                      leftSubheading={
                        <Container className={'px-0 d-flex flex-column'}>
                          <span>
                            Referred to as MetLaw®, the Legal Services Plan is
                            offered through MetlifeLegal Plans. The plan provides 
                            access to legal advice and representation on a wide 
                            range of issues at an affordable cost.
                          </span>
                        </Container>
                      }
                      className={'mb-12'}
                    />
                  </div>
                </Row>
                <Col className={'mt-10 overflow-auto'}>
                  <GenericTable
                    className='custom-row-1'
                    selectedCellPosition={getCellCoordinates(benefit)}
                    tableData={getTableData(benefit['availablePlans'])}
                  />
                </Col>
              </Container>
            );
          })}
        </div>
      </Row>
    </Container>
  );
};

export default LifestyleBenefitsTab;
